import { PrimaryButton } from '@components/Buttons/PrimaryButton';
import { ArquivoModalBar } from '@components/Modal/ArquivoModalBar';
import { ArquivoModalTable } from '@components/Modal/ArquvioModalTable';
import { ModalWindow } from '@components/Modal/ModalWindow';
import { ModalWindowActions } from '@components/Modal/ModalWindowActions';
import { ModalWindowContent } from '@components/Modal/ModalWindowContent';
import { ModalWindowTitle } from '@components/Modal/ModalWindowTitle';
import { TableWrapper } from '@components/Table/TableWrapper';
import { useField } from '@hooks/useField';
import { IFile, useFileUpload } from '@hooks/useFileUpload';
import { useForm } from '@hooks/useForm';
import { IModalWindow } from '@hooks/useModalWindow';
import { useValidation } from '@hooks/useValidation';
import { makeStyles } from '@material-ui/core';
import { EnumEmpresa, IComboEmpresa } from '@model/Empresa';
import { EnumOperadora, IComboOperadora } from '@model/Operadora';
import { IImportarRequest, useContaService } from '@services/ContaService';
import { yup } from '@validations/Yup';
import React from 'react';
import { ContaImportarFormulario } from './ContaImportarFormulario';

export type ContaImportarModalProps = {
    modal: IModalWindow
    empresaCombo: IComboEmpresa
    //operadoraCombo: IComboOperadora
    numerosContrato: string[]
}

export function ContaImportarModal({ modal, empresaCombo, numerosContrato }: ContaImportarModalProps) {
    const cls = useStyles();

    const contaService = useContaService();
    const form = useForm<IImportarRequest>({
        empresaId: useField(EnumEmpresa.None),
        numeroContrato: useField(numerosContrato)
    });

    const validation = useValidation({
        empresaId: yup.number().required(),
        numerosContrato: yup.string().required()
    })

    const handleCollectAditionalParams = React.useCallback((file: IFile) => {
        return form.getInputValues();
    }, [form]);

    const fileUpload = useFileUpload({
        uploadFunction: contaService.importar,
        onCollectAditionalParams: handleCollectAditionalParams
    });

    const handleConfirm = React.useCallback(() => {
        if (!fileUpload.isLoading) {
            const values = form.getInputValues();
            
            validation.validate(values)
                .then(() => {
                    fileUpload.handleConfirm();
                })
                .catch(form.setErrorsFromYup)
        }
    }, [fileUpload, form, validation]);

    const handleEnter = React.useCallback(() => {
        fileUpload.clear();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    return (
        <ModalWindow
            modal={modal}
            disabled={fileUpload.isLoading}
            size="md"
            TransitionProps={{
                onEnter: handleEnter
            }}
        >
            <ModalWindowTitle title="Importar Conta" />
            
            <ModalWindowContent>
                <ContaImportarFormulario 
                    form={form}
                    empresaCombo={empresaCombo}
                    numerosContrato={numerosContrato}
                />

                <ArquivoModalBar 
                    className={cls.table}
                    accept=".zip"
                    multiple
                    onFilesSelected={fileUpload.handleFilesSelected}
                />

                <TableWrapper className={cls.table}>
                    <ArquivoModalTable 
                        data={fileUpload.data}
                        isLoading={fileUpload.isLoading}
                    />
                </TableWrapper>
            </ModalWindowContent>

            <ModalWindowActions>
                <PrimaryButton 
                    onClick={handleConfirm}
                    disabled={!fileUpload.hasAwaitting}
                >Importar Contas</PrimaryButton>
            </ModalWindowActions>
        </ModalWindow>
    )
}

const useStyles = makeStyles(theme => ({
    table: {
        marginTop: theme.spacing(3)
    }
}));